import * as React from 'react'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../../assets/jss/dorm-app/customSelectStyle'

const useStyles = makeStyles(styles)

export default function UniversitySelect(props) {
  const classes = useStyles()

  const { state, dispatch } = props

  return (
    <FormControl fullWidth className={classes.selectFormControl}>
      <InputLabel htmlFor="university" className={classes.selectLabel}>
        Universität
      </InputLabel>
      <Select
        MenuProps={{
          className: classes.selectMenu,
        }}
        classes={{
          select: classes.select,
        }}
        value={state.university}
        onChange={(e) =>
          dispatch({
            type: 'field',
            field: 'university',
            value: e.currentTarget.getAttribute('data-value'),
          })
        }
        inputProps={{
          name: 'university',
          id: 'university',
        }}>
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value="TU">
          TU
        </MenuItem>
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value="LMU">
          LMU
        </MenuItem>
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value="FH">
          Hochschule München
        </MenuItem>
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value="HFF München">
          HFF München
        </MenuItem>
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value="ABK">
          Akademie der Bildenden Künste
        </MenuItem>
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value="HMTM">
          Hochschule für Musik und Theater München
        </MenuItem>
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value="FOM">
          FOM
        </MenuItem>
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value="KSH">
          Katholische Stiftungshochschule München
        </MenuItem>
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value="HsPhilosophie">
          Hochschule für Philosophie
        </MenuItem>
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value="HsPolitik">
          Hochschule für Politik
        </MenuItem>
      </Select>
    </FormControl>
  )
}
